import Vue from 'vue';

export default {
    /**
     * Set players
     *
     * @param {object} state    Vuex state.
     * @param {object}  payload    Array of players objects.
     * @param {string} payload.type     Player type.
     * @param {object} payload.data     Player data
     */
    setPlayers(state, { type, data }) {
        state[`${type}Players`] = {
            ...state[`${type}Players`],
            ...data,
        };
    },

    /**
     * Add player
     *
     * @param {object}  state               Vuex state.
     * @param {object}  payload              Array of players objects.
     * @param {string}  payload.showHash     Show hash.
     * @param {object}  payload.data        Player data.
     */
    addPlayer(state, { showHash, data }) {
        state.archivePlayers[showHash] = {
            ...state.archivePlayers[showHash],
            ...data,
        };
    },

    /**
     * Delete player
     *
     * @param {object}  state               Vuex state.
     * @param {object}  payload              Array of players objects.
     * @param {string}  payload.showHash     Show hash.
     * @param {string}  payload.playerHash   Player hash.
     * @param {string}  payload.type         Player type.
     */
    deletePlayer(state, { showHash, playerHash, type }) {
        Vue.delete(state[`${type}Players`][showHash], [playerHash]);
    },

    /**
     * Update player
     *
     * @param {object}  state               Vuex state.
     * @param {object}  payload              Array of players objects.
     * @param {string}  payload.showHash     Show hash.
     * @param {string}  payload.playerKey    Player Key.
     * @param {string}  payload.type         Player type.
     * @param {object}  payload.data         Player object.
     */
    updatePlayer(state, { showHash, playerKey, type, data }) {
        state[`${type}Players`][showHash][playerKey] = {
            ...state[`${type}Players`][showHash][playerKey],
            ...data,
        };
    },

    /**
     * Set track player config
     *
     * @param {object}  state               Vuex state.
     * @param {object}  payload              Payload data.
     * @param {string}  payload.showHash     Show hash.
     * @param {string}  payload.trackNo      Player track number.
     * @param {object}  payload.data         Player config object.
     */
    setTrackPlayerConfig(state, { showHash, trackNo, data }) {
        if (! state.trackPlayersConfig[showHash]) {
            Vue.set(state.trackPlayersConfig, showHash, {});
        }

        state.trackPlayersConfig[showHash] = {
            ...state.trackPlayersConfig[showHash],
            [trackNo]: data,
        };
    },

    /**
     * Update track player config
     *
     * @param {object}  state               Vuex state.
     * @param {object}  payload              Payload data.
     * @param {string}  payload.showHash     Show hash.
     * @param {string}  payload.trackNo      Player track number.
     * @param {object}  payload.data         Player config object.
     */
    updateTrackPlayerConfig(state, { showHash, trackNo, data }) {
        state.trackPlayersConfig[showHash][trackNo] = {
            ...state.trackPlayersConfig[showHash][trackNo],
            ...data,
        };
    },

    /**
     * Add recent players
     *
     * @param {object}  state               Vuex state.
     * @param {object}  payload              Payload data.
     * @param {string}  payload.type         Players type.
     * @param {string}  payload.showHash     Show hash.
     * @param {string}  payload.players     Array with players.
     */
    addRecentPlayers(state, { type, showHash, players }) {
        if (! state[`${type}RecentPlayers`]?.[showHash]) {
            Vue.set(state[`${type}RecentPlayers`], showHash, []);
        }

        state[`${type}RecentPlayers`][showHash] = [...players];
    },

    /**
     * Clears recent players
     *
     * @param {object}  state               Vuex state.
     * @param {object}  payload              Payload data.
     * @param {string}  payload.type         Players type.
     */
    clearRecentPlayers(state, { type }) {
        state[`${type}RecentPlayers`] = {};
    },
};
